export const FILTER_SELECTION_PENDING = '[Filter]/FILTER_SELECTION_PENDING';
export const FILTER_SELECTION_SUCCESS = '[Filter]/FILTER_SELECTION_SUCCESS';
export const FILTER_RESET = '[Filter]/FILTER_RESET';
export const FILTER_DELETE_PENDING = '[Filter]/FILTER_DELETE_PENDING';
